/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing a meal-prep step like resting dough or marinating meat.`)
};

const es_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar un paso de la preparación de comidas, como dejar reposar la masa o marinar carne.`)
};

const de_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Schritt bei der Essensvorbereitung stoppen, etwa Teig ruhen lassen oder Fleisch marinieren.`)
};

const nl_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een stap in de maaltijdvoorbereiding timen, zoals deeg laten rusten of vlees marineren.`)
};

const fr_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronométrer une étape de préparation culinaire comme le repos d’une pâte ou la marinade d’une viande.`)
};

const it_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrare un passaggio della preparazione dei pasti come far riposare l'impasto o marinare la carne.`)
};

const pt_br2_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar uma etapa do preparo de refeições, como deixar a massa descansar ou marinar a carne.`)
};

const pt_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronometrar um passo da preparação de refeições, como deixar a massa repousar ou marinar carne.`)
};

const ja_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生地を寝かせる、肉に下味をつけるといった仕込みの1工程を計測する。`)
};

const zh_timer_u15m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为备餐步骤计时，比如醒面或腌制肉类。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_use3", locale)
	if (locale === "en") return en_timer_u15m_use3(inputs)
	if (locale === "es") return es_timer_u15m_use3(inputs)
	if (locale === "de") return de_timer_u15m_use3(inputs)
	if (locale === "nl") return nl_timer_u15m_use3(inputs)
	if (locale === "fr") return fr_timer_u15m_use3(inputs)
	if (locale === "it") return it_timer_u15m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_use3(inputs)
	if (locale === "pt") return pt_timer_u15m_use3(inputs)
	if (locale === "ja") return ja_timer_u15m_use3(inputs)
	return zh_timer_u15m_use3(inputs)
};